import { environment } from '@/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import {
  User,
  UserCreateParams,
  UserFindAllParams,
} from '../core/type';
import { PaginatedResponse } from '@/app/common/utils/pagination/types';
import { UserService } from '../core/service';

@Injectable()
export class UserApiService implements UserService {
  private readonly defaultUrl = `${environment.apiHost}/user`;

  constructor(private httpClient: HttpClient) {}

  getById(id: number): Observable<User> {
    return this.httpClient.get<User>(`${this.defaultUrl}/${id}`);
  }

  findAll(
    filter?: UserFindAllParams | undefined
  ): Observable<PaginatedResponse<User>> {
    return this.httpClient.get<PaginatedResponse<User>>(this.defaultUrl, {
      params: { ...filter },
    });
  }

  update(id: number, data: Omit<User, 'id'>): Observable<void> {
    let formData: FormData = new FormData();

    Object.keys(data).forEach((key) => {
      formData.append(key, (data as any)[key]);
    });

    return this.httpClient.patch<void>(
      `${this.defaultUrl}/${id}`,
      formData
    ) as any;
  }

  create(data: Omit<UserCreateParams, 'id'>) {
    let formData: FormData = new FormData();

    Object.keys(data).forEach((key) => {
      formData.append(key, (data as any)[key]);
    });

    return this.httpClient.post<{ jwt: string }>(
      this.defaultUrl,
      formData
    ) as any;
  }

  delete(id: number): Observable<void> {
    throw new Error('Method not implemented.');
  }

  setActive(id: number, isActive: boolean): Observable<void> {
    return this.httpClient.patch<void>(`${this.defaultUrl}/${id}/active`, {
      isActive,
    });
  }
}
